export default function formatDateWithTime(date: Date): string {
  const threeLetterMonth = date.toLocaleString("default", {
    timeZone: "UTC",
    month: "short",
  });

  return `${threeLetterMonth} ${date.getDate()} ${date.getHours()}:${String(date.getMinutes()).padStart(2, "0")}`;
}
